import { useEffect, useState } from "react";

// TLP 2.0 colors per FIRST.org standard (GREEN dimmed for readability)
const TLP_STYLE = {
  "TLP:RED":          { bg: "#FF2B2B", fg: "#FFFFFF" },
  "TLP:AMBER+STRICT": { bg: "#FFC000", fg: "#000000" },
  "TLP:AMBER":        { bg: "#FFC000", fg: "#000000" },
  "TLP:GREEN":        { bg: "#1F7A37", fg: "#FFFFFF" },
  "TLP:CLEAR":        { bg: "#FFFFFF", fg: "#000000", border: "1px solid #888" },
};
// Fallback for any non-TLP classification label
const DEFAULT_STYLE = { bg: "#5A5A5A", fg: "#FFFFFF" };

export default function ClassificationBar() {
  const [tlp, setTlp] = useState(null);

  useEffect(() => {
    const BASE = process.env.REACT_APP_API_URL || "";
    fetch(`${BASE}/api/classification`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && d.tlp && setTlp(d.tlp))
      .catch(() => {});
  }, []);

  if (!tlp) return null;
  const style = TLP_STYLE[tlp] || DEFAULT_STYLE;

  return (
    <div
      style={{
        position: "sticky",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: style.bg,
        color: style.fg,
        textAlign: "center",
        fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
        fontWeight: 700,
        fontSize: 13,
        letterSpacing: 1,
        padding: "4px 8px",
        border: style.border || "none",
        boxShadow: "0 1px 2px rgba(0,0,0,0.2)",
      }}
    >
      {tlp}
    </div>
  );
}
